import { useQuery } from "@tanstack/react-query";
import {
  getAppSettings,
  getVisibleAppSettings,
  getSettingAudits,
} from "@/api/appSettings";
import { AppSettingsQueryKeys } from "./appSettingsQueryKeys";

export const useAppSettings = (enabled: boolean = true) => {
  return useQuery({
    queryKey: [AppSettingsQueryKeys.AppSettings],
    queryFn: ({ signal }) => getAppSettings({ signal }),
    enabled,
  });
};

export const useVisibleAppSettings = (enabled: boolean = true) => {
  return useQuery({
    queryKey: [AppSettingsQueryKeys.VisibleAppSettings],
    queryFn: ({ signal }) => getVisibleAppSettings({ signal }),
    enabled,
  });
};

// Admin change-history for a setting (e.g. crypto_sweep) — who/when/old->new.
export const useSettingAudits = (key?: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: [AppSettingsQueryKeys.SettingAudits, key],
    queryFn: () => getSettingAudits({ key, pageSize: 20 }),
    enabled,
  });
};
